/* eslint-disable no-undef */
import React, { useState } from 'react';
import './Outtro.css';
import Loader from './loader'; // Import the Loader component
import MajorVirtualTunnelLogo from './media/images/Major Tunnel logo white.png'; // Import the logo
import { RiResetLeftLine } from 'react-icons/ri';
import { RiContactsBook2Line } from 'react-icons/ri';

const Outtro = ({ showOuttro, handleOuttroClick }) => {
  const [animationState, setAnimationState] = useState('initial'); // 'initial', 'button', 'exit'

  const handleButtonClick = () => {
    setAnimationState('exit'); // Trigger the exit animation
    setTimeout(() => {
      handleOuttroClick(); // Call the parent function after animation
    }, 1000); // Match the duration of the exit animation
  };

  return (
    <div
      className={`portal-overlay ${
        !showOuttro ? 'portal-hidden' : ''
      } ${animationState}`}
    >
      {/* Logo Animation */}
      <img
        src={MajorVirtualTunnelLogo}
        alt="Major Virtual Tunnel Logo"
        className={`portal-logo ${animationState}`}
      />

      {/* Loader/Button Animation */}
      <div
        className={`loader-button ${animationState}`}
        onClick={handleButtonClick}
      >
        {animationState === 'initial' && <Loader dimensions={'100px'} />} {/* Show the loader */}
        {animationState === 'initial' && <div className="outtro-text">{window.location.pathname.replace('/', '') === 'eng' ? 'Back to the site' : 'Torna al sito'}</div>} {/* Show the button text */}
        {animationState === 'exit' && <Loader dimensions={'150px'} />} {/* Show the loader */}
      </div>

  <button
                    onClick={() => {window.location.assign('https://majorvirtual.it/contacts');}}
                    style={{
                      position: 'fixed',
                      bottom: '80px',
                      right: '20px',
                      padding: '10px 15px',
                      background: 'rgba(0, 0, 0, 0.6)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      fontSize: '16px'
                    }}
                  >
                    <RiContactsBook2Line />
                  </button>
      <button
              onClick={() => window.location.reload()}
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                padding: '10px 15px',
                background: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              <RiResetLeftLine />
            </button>
    </div>
  );
};

export default Outtro;